import React from "react";
import { Card, Typography } from "@mui/material";

import useStyles from "./FertilizerDetailsStyles";

function FertilizerDetails(props) {
  const classes = useStyles();
  let cardClassName = classes.fertilizerTypeCardOne;
  if (props.index === 1) {
    cardClassName = classes.fertilizerTypeCardTwo;
  } else if (props.index === 2) {
    cardClassName = classes.fertilizerTypeCardThree;
  }
  let overUsed =
    props.userAndAdvisedDiff !== 0 &&
    props.userAndAdvisedDiff.startsWith("-") === false &&
    props.userAndAdvisedDiff.startsWith("0 ") === false
      ? classes.overUsed
      : classes.underUsed;

  let regex = /\b0 grams\b/;

  return (
    <>
      {
        <Card elevation={3} className={cardClassName}>
          <div className={classes.icons}>
            <span className={classes.countCircle}>
              {props.index === 0 ? "5" : props.index === 1 ? "6" : "7"}
            </span>
            <span>
              {props.index === 0 ? (
                <svg
                  width="31"
                  height="38"
                  viewBox="0 0 31 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.05281 0C0.728717 0.00117001 0.400821 0.0195977 0.0699973 0.0590854C-0.106677 2.5363 0.585972 4.44134 1.73872 6.64449C1.73872 6.64449 1.10457 9.37734 0.90447 10.7626C0.537381 13.3048 0.22089 15.868 0.234054 18.4357C0.247217 20.8275 0.621622 23.2061 0.90447 25.5816C1.13409 27.5089 1.73872 31.3454 1.73872 31.3454C0.672564 33.4844 -0.267866 35.5338 0.0699973 37.9308C2.80053 38.092 5.0525 37.3244 7.57157 36.2851H23.4036C25.5685 37.3384 27.6441 38.2645 30.071 37.9308C30.2476 35.4536 29.555 33.5485 28.4022 31.3454C28.4022 31.3454 29.0335 28.6122 29.2365 27.2272C29.5919 24.8042 29.9069 22.3612 29.9069 19.9126C29.9069 17.4014 29.5278 14.9032 29.2365 12.4087C29.011 10.4809 28.4022 6.64494 28.4022 6.64494C29.4684 4.50589 30.4088 2.45655 30.071 0.0595348C27.3404 -0.101631 25.0885 0.66619 22.5694 1.70519H7.57149C5.44061 0.846384 3.322 -0.00710922 1.05273 0.000453752L1.05281 0ZM15.4292 6.83116C15.9077 6.83116 16.3851 7.00637 16.7473 7.36878C17.1954 7.81749 17.3796 8.46624 17.236 9.09135C17.3527 9.1633 17.461 9.24872 17.5587 9.34465C18.2832 10.0692 18.2721 11.2526 17.535 11.9886C17.4276 12.096 17.3001 12.1788 17.1717 12.2571L17.4633 12.7231C17.7283 13.1466 17.9243 13.5974 18.0673 14.0616L19.0578 13.268C19.1718 13.1735 19.3143 13.1203 19.4623 13.1171C19.7443 13.1118 19.9979 13.2879 20.0921 13.5538C20.1862 13.8197 20.0994 14.116 19.8768 14.2891L18.3157 15.5408C18.3537 16.6529 18.0758 17.7737 17.4633 18.7528L17.0871 19.3542C16.8929 19.656 16.4922 19.7453 16.188 19.5548C15.884 19.3641 15.7896 18.9646 15.9765 18.6583L16.3526 18.0569C16.4679 17.8723 16.5668 17.6793 16.6522 17.4836L14.8606 16.2884V16.2881C14.6166 16.1305 14.5058 15.8309 14.5879 15.5525C14.6701 15.274 14.9258 15.0827 15.2162 15.0827C15.3487 15.0827 15.478 15.1228 15.5874 15.198L16.99 16.1346C17.0751 15.2003 16.8694 14.2462 16.3526 13.4193L16.2294 13.2247C16.1666 13.3139 16.1127 13.4102 16.0349 13.4883C15.299 14.2242 14.1155 14.233 13.391 13.5093C13.2938 13.4111 13.2076 13.3037 13.135 13.1867C12.5108 13.3297 11.8638 13.1449 11.4151 12.6979C10.6905 11.9734 10.6993 10.79 11.4361 10.054C10.7116 9.32943 10.723 8.146 11.4598 7.41C12.1958 6.67406 13.3792 6.66528 14.1038 7.38894C14.4718 7.02096 14.9511 6.83464 15.4294 6.83084L15.4292 6.83116ZM7.20802 23.585H22.933V30.1371H7.20802V23.585Z"
                    fill="black"
                  />
                </svg>
              ) : props.index === 1 ? (
                <svg
                  width="37"
                  height="39"
                  viewBox="0 0 37 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27.6401 34.229C29.6502 33.3006 32.9271 32.1651 32.9641 27.2454C32.9641 26.6884 32.5127 26.2363 31.955 26.2363C31.3973 26.2363 30.9459 26.6884 30.9459 27.2454C30.9169 30.7705 28.9526 31.4035 26.82 32.3884C26.4763 32.5485 26.2368 32.895 26.2368 33.3C26.2368 33.857 26.6882 34.3091 27.2459 34.3091C27.3858 34.3091 27.519 34.2808 27.6401 34.229Z"
                    fill="black"
                  />
                  <path
                    d="M31.0333 4.09489C27.7396 1.89911 26.4385 2.72522 23.4711 1.36967L20.717 0.111673C20.5529 0.0410363 20.3726 0 20.1822 0C19.4395 0 18.8367 0.602764 18.8367 1.34545C18.8367 1.80493 19.0675 2.20924 19.4193 2.45276L21.9501 4.20185C26.5226 5.01451 30.0309 8.91094 30.2495 13.6611L32.964 12.1091V5.38182L31.0333 4.09489Z"
                    fill="black"
                  />
                  <path
                    d="M37.0001 14.1273H35.6546C34.9119 14.1273 34.3092 13.5245 34.3092 12.7818V4.70911C34.3092 3.96642 34.9119 3.36366 35.6546 3.36366H37.0001V14.1273Z"
                    fill="black"
                  />
                  <path
                    d="M26.0959 23.0927C27.2651 20.5404 28.9274 16.5208 28.9274 14.1273C28.9274 9.29709 25.0121 5.38182 20.1819 5.38182C18.0157 5.38182 16.0379 6.17362 14.5108 7.47804L13.9942 6.78244C13.6551 6.32431 13.1183 6.05455 12.5478 6.05455C12.2592 6.05455 11.9753 6.12384 11.7197 6.25637L2.67956 10.9392C2.18915 11.1928 1.84202 11.6584 1.73842 12.2006L0.0539097 21.0247C0.0182551 21.2124 9.15527e-05 21.4021 9.15527e-05 21.5939C9.15527e-05 21.9941 0.0794733 22.3904 0.233528 22.7597L6.10711 36.856C6.48249 37.7582 7.36376 38.3455 8.34057 38.3455C8.6628 38.3455 8.981 38.2755 9.27297 38.1403L27.5859 29.6861C28.5204 29.2556 28.9274 28.4227 28.9274 27.5818C28.9274 27.1264 28.7612 26.6851 28.4894 26.3184L26.0959 23.0927ZM20.1819 7.4C23.8913 7.4 26.9092 10.4179 26.9092 14.1273C26.9092 15.4895 26.1201 18.0277 24.7161 21.2333L15.7197 9.10806C16.9535 8.00613 18.5176 7.4 20.1819 7.4V7.4ZM19.8455 28.9273C19.5818 28.9273 19.3437 28.8237 19.1641 28.6582C18.5566 28.0473 17.6928 27.5818 16.8183 27.5818C14.8001 27.5818 15.0524 28.2545 12.7819 28.2545C7.58038 28.2545 4.70918 23.7365 4.70918 18.1636C4.70918 16.9305 4.9258 15.7546 5.30387 14.6621C6.29076 15.9793 7.76673 16.8182 9.41827 16.8182C11.1701 16.8182 11.1001 16.1455 12.7819 16.1455C16.126 16.1455 18.8365 18.8559 18.8365 22.2C18.8365 22.6036 18.784 22.9931 18.708 23.3746C18.0433 22.8216 16.9663 22.2 15.4728 22.2C14.1274 22.2 12.7819 23.5455 11.4365 22.2C12.1092 24.2182 14.1274 25.5636 16.8183 25.5636C18.4321 25.5636 20.8546 26.8613 20.8546 27.9182C20.8546 28.4752 20.4032 28.9273 19.8455 28.9273Z"
                    fill="black"
                  />
                  <path
                    d="M20.1822 8.74548C19.4388 8.74615 18.8367 9.34757 18.8367 10.0909C18.8367 10.7132 19.0372 11.3207 19.4085 11.8205L22.6827 16.2215C22.9619 16.5969 23.4019 16.8182 23.8694 16.8182C24.5448 16.8182 25.1382 16.3567 25.305 15.7028C25.4846 15.0005 25.564 14.4764 25.564 14.1273C25.564 11.1599 23.1496 8.74548 20.1822 8.74548Z"
                    fill="black"
                  />
                  <path
                    d="M3.44079 6.3518C3.39505 6.26098 3.3641 6.16277 3.3641 6.05446C3.3641 5.68311 3.66549 5.38173 4.03683 5.38173C4.29987 5.38173 4.52254 5.53646 4.63287 5.75711L5.69241 7.86342L7.70656 6.82002L6.8051 5.00635C6.75869 4.91553 6.72774 4.81731 6.72774 4.709C6.72774 4.33766 7.02912 4.03627 7.40047 4.03627C7.6635 4.03627 7.88618 4.191 7.9965 4.41166L8.89729 6.20313L10.8186 5.20816L8.76812 1.046C8.64905 0.805838 8.40956 0.672638 8.15661 0.672638C8.0557 0.672638 7.95278 0.698202 7.85658 0.747983L1.03647 4.28115C0.810431 4.3982 0.673195 4.62693 0.673195 4.86507C0.673195 4.97069 0.693377 5.07766 0.743831 5.17857L2.80372 9.35956L4.49967 8.48098L3.44079 6.3518Z"
                    fill="black"
                  />
                </svg>
              ) : (
                <svg
                  width="35"
                  height="33"
                  viewBox="0 0 35 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.7444 12.061C32.9872 13.7015 31.7004 14.1687 29.9726 14.1687C28.5422 14.1687 27.6981 13.5585 26.5235 13.5585C23.5798 13.5585 21.193 15.9454 21.193 18.8891C21.193 19.2321 21.2287 19.567 21.2902 19.8925C22.0565 19.5199 22.9307 19.2032 23.7015 19.2032C25.5828 19.2032 26.2099 19.8304 26.2099 19.8304C23.8018 19.8304 21.0569 21.2928 19.3116 22.966C19.3116 14.1863 19.1755 9.5895 18.0574 7.91509C19.8139 9.67166 20.4762 10.3358 20.5571 12.4573C21.7072 11.5386 22.4472 10.1288 22.4472 8.54221C22.4472 3.65821 16.5059 4.12102 16.1911 0.0993042C13.9359 1.34414 12.4133 3.67326 12.4133 6.3473C12.4133 9.3813 14.3718 11.97 17.1412 13.0343C17.3807 15.4205 17.4215 18.0086 17.4284 21.0357C15.8625 14.8134 10.9853 11.6778 6.76922 11.6778C2.08965 11.6778 0.647279 14.4403 9.15527e-05 17.8336C0.711872 17.5408 1.49264 17.3219 2.06582 17.3219C6.82817 17.3219 6.76922 24.8473 11.1591 24.8473C11.7109 24.8473 12.2691 24.7376 12.8052 24.5432C12.3017 21.8779 11.1591 19.2032 11.1591 19.2032C15.6003 22.3758 16.8031 26.264 16.8031 31.7456V32.9999H18.6845V31.7456C18.6845 25.4744 20.86 23.5931 23.0743 23.5931C24.8321 23.5931 24.9776 24.2202 26.837 24.2202C31.5129 24.2202 34.9896 20.0085 34.9896 14.8134C34.9896 14.0107 34.8748 12.9797 34.7444 12.061V12.061Z"
                    fill="#050003"
                  />
                </svg>
              )}
              <p>{props.fertilizerType}</p>
            </span>
          </div>
          <div className={classes.manureDetails}>
            <div>
              <Typography variant="h6" className={overUsed}>
                {regex.test(props.userUses)
                  ? props.userUses.replace("0 grams", "")
                  : props.userUses}{" "}
                {props.index === 2 && props.paddy2022
                  ? props.label.quintal
                  : props.index === 2
                  ? props.label.tractor
                  : regex.test(props.userAndAdvisedDiff)
                  ? props.userAndAdvisedDiff.replace("0 grams", "")
                  : ` (${props.userAndAdvisedDiff}) `}
              </Typography>
              <Typography variant="h6" className={classes.manureTitle}>
                {props.label.farmerUsesManure}
              </Typography>
            </div>
            <div>
              <Typography variant="h6" className={classes.manure}>
                {regex.test(props.averageUses)
                  ? props.averageUses.replace("0 grams", "")
                  : props.averageUses}{" "}
                {props.index === 2 && props.paddy2022
                  ? props.label.quintal
                  : props.index === 2
                  ? props.label.tractor
                  : ""}
              </Typography>
              <Typography variant="h6" className={classes.manureTitle}>
                {props.label.averageUsesManure}
              </Typography>
            </div>
            {props.index !== 2 && (
              <div>
                <Typography variant="h6" className={classes.manure}>
                  {regex.test(props.advisedUses)
                    ? props.advisedUses.replace("0 grams", "")
                    : props.advisedUses}{" "}
                  {props.index === 2 && props.paddy2022
                    ? props.label.quintal
                    : props.index === 2
                    ? props.label.tractor
                    : ""}
                </Typography>
                <Typography variant="h6" className={classes.manureTitle}>
                  {props.label.advisedManure}
                </Typography>
              </div>
            )}
          </div>
        </Card>
      }
    </>
  );
}

export default FertilizerDetails;
